import {
  ICustomDictionaryType,
  IDictionaryTypeCustomField,
} from '~/services/api/dictionaries/types';

export const getAddLabel = (dictionaryType?: ICustomDictionaryType): string =>
  dictionaryType?.addButtonLabel || `Add ${dictionaryType?.name}`;

export const getEditLabel = (dictionaryType?: ICustomDictionaryType): string => {
  if (dictionaryType?.editButtonLabel) return dictionaryType.editButtonLabel;

  const addLabel = getAddLabel(dictionaryType);

  return addLabel.startsWith('Add ')
    ? `Edit ${addLabel.slice('Add '.length)}`
    : `Edit ${dictionaryType?.name}`;
};

export const isRequiredCustomField = ({ title }: IDictionaryTypeCustomField): boolean =>
  title === 'Abbreviation';
